import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import "./assets/styles/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import GlobalProvider from "./context/Provider";
import "bootstrap/dist/css/bootstrap.min.css";
import './tailwind.css';

ReactDOM.render(
  <Router>
    <GlobalProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </GlobalProvider>
  </Router>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
